import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { APIServices } from './../../../config/app-config';

import { AuthInfo } from './../../../model/entities/login/authInfo';
import { UserInfo } from './../../../model/entities/users/userInfo';
import { UserInfoSession } from './../../../model/entities/users/userInfoSession';

@Injectable()
export class LoginService {

    constructor(private http: HttpClient) {}

    Authenticate(params: AuthInfo): Observable<any> {
        return this.http.post(APIServices.security.Authenticate, '')
        .pipe(
          map(result => {
            return result;
          }),
          catchError(error => {
            return throwError(new Error(error));
          })
        );
    }

    CreateToken(params: AuthInfo): Observable<any> {
        return this.http.post(APIServices.admin.login.GetToken, params)
        .pipe(
          map(result => {
            return result;
          }),
          catchError(error => {
            return throwError(new Error(error));
          })
        );
    }

  /*AuthenticateUser(params: AuthInfo): Observable<any> {
    return this.http.post(APIServices.admin.Login, params)
        .pipe(
          map(result => {
            return result;
          }),
          catchError(error => {
            return throwError(new Error(error));
          })
        );
    }*/

  UserInfo(): Observable<UserInfoSession> {
    return this.http.get<UserInfoSession>(APIServices.admin.common.UserInfo)
        .pipe(
          map(result => {
            return result;
          }),
          catchError(error => {
            return throwError(new Error(error));
          })
        );
    }

  GetStructure(): Observable<any> {
    return this.http.get(APIServices.admin.common.GetStructure)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

  getStructureWO(): any {
    return this.http.get(APIServices.admin.common.GetStructureWO)
      .pipe(
        map(result => {
          return result;
        }),
        catchError(error => {
          return throwError(new Error(error));
        })
      );
  }

}
